module.exports = __webpack_public_path__ + "img/KinokoTable56.6bc3600a.jpg";